import type { ApplyEventsSearchCriteriaAction, ClearEventsSearchCriteriaAction } from "domains/events/actionTypes";
import { TopicEventsType } from "domains/events/actionTypes";

export const applyEventsSearchCriteria = (
  payload: ApplyEventsSearchCriteriaAction["payload"],
): ApplyEventsSearchCriteriaAction => ({
  type: TopicEventsType.APPLY_SEARCH_CRITERIA,
  payload,
});

export const clearEventsSearchCriteria = (): ClearEventsSearchCriteriaAction => ({
  type: TopicEventsType.CLEAR_SEARCH_CRITERIA,
});
